var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { ArrayMaxSize, ArrayMinSize, IsArray, IsBoolean, IsEnum, IsInt, IsOptional, IsString, IsUUID, Min, ValidateNested, } from 'class-validator';
import { TreatmentLocation } from '../../calls/enums/treatment-location.enum.js';
import { CreateAppointmentSeriesParticipantDto } from './create-appointment-series.dto.js';
/**
 * Edit the default fields of a series WITHOUT changing its rrule.
 *
 * Bumps `ruleVersion`. Past materialized rows retain their old `ruleVersion`
 * (and surface as "orphaned overrides" in the UI). Future virtual occurrences
 * inherit the new defaults at expansion time.
 */
export class UpdateAppointmentSeriesDefaultsDto {
    defaultTherapistId;
    defaultRoomId;
    defaultOfficeProductAssignmentId;
    defaultTreatmentLocation;
    defaultPlannedDuration;
    defaultService;
    defaultDescription;
    defaultDeviceIds;
    defaultParticipants;
    confirmConflicts;
}
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateAppointmentSeriesDefaultsDto.prototype, "defaultTherapistId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateAppointmentSeriesDefaultsDto.prototype, "defaultRoomId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateAppointmentSeriesDefaultsDto.prototype, "defaultOfficeProductAssignmentId", void 0);
__decorate([
    IsEnum(TreatmentLocation),
    IsOptional(),
    __metadata("design:type", String)
], UpdateAppointmentSeriesDefaultsDto.prototype, "defaultTreatmentLocation", void 0);
__decorate([
    IsInt(),
    Min(1),
    IsOptional(),
    __metadata("design:type", Number)
], UpdateAppointmentSeriesDefaultsDto.prototype, "defaultPlannedDuration", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateAppointmentSeriesDefaultsDto.prototype, "defaultService", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateAppointmentSeriesDefaultsDto.prototype, "defaultDescription", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateAppointmentSeriesDefaultsDto.prototype, "defaultDeviceIds", void 0);
__decorate([
    IsArray(),
    ArrayMinSize(1),
    ArrayMaxSize(5),
    ValidateNested({ each: true }),
    Type(() => CreateAppointmentSeriesParticipantDto),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateAppointmentSeriesDefaultsDto.prototype, "defaultParticipants", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateAppointmentSeriesDefaultsDto.prototype, "confirmConflicts", void 0);
//# sourceMappingURL=update-appointment-series-defaults.dto.js.map